if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        'use strict';
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}